import { userSignal, userRoleSignal, userPermissionsSignal, userIdSignal } from './auth.state';
import { isMapView } from './dashboard.state';
import { currentUserSignal } from './auth.state';
import { resetClientContext } from '../compartidos/services/client-context.state';
import { alarmasPermitidasSignal } from './alarm-context.state';

export function resetAppState() {
  currentUserSignal.set(null);
  userSignal.set(null);
  userRoleSignal.set(null);
  userPermissionsSignal.set([]);
  userIdSignal.set(null);

  isMapView.set(true);
  resetClientContext();
  alarmasPermitidasSignal.set(null);

}


